import React from "react";
import { Provider } from "react-redux";
import AppStore from "../redux/store";
import { ATSWrapper } from "@rankmi/ats-app"
import { RequestsApp } from "@rankmi/workflows-app"
import "antd/dist/antd.css";
import '@rankmi/rankmi-styles/dist/css/reset-ant/main.css';
import "@rankmi/workflows-app/dist/index.css";
import '@rankmi/rankmi-components/dist/index.css';
import { FormOptionalSection } from "@rankmi/rankmi-optionals";
import "./Requests.scss";


const Container = ({ store = AppStore }) => {

  return (
    <ATSWrapper>
      <Provider store={store}>
        <div className="workflows-fix">
          <RequestsApp activeModule="rkm_14" formOptional={FormOptionalSection} />
        </div>
      </Provider>
    </ATSWrapper>
  );
};

export default Container;
